var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "Aside" }, [
    _c("div", { staticClass: "aside_left" }, [
      _vm._m(0),
      _c("div", { staticClass: "bottom" }, [
        _c(
          "ul",
          { staticClass: "bottom_ul" },
          _vm._l(_vm.menuList, function (item, index) {
            return _c(
              "li",
              {
                directives: [
                  {
                    name: "auth",
                    rawName: "v-auth",
                    value: item.auth,
                    expression: "item.auth",
                  },
                ],
                key: item.id,
                staticClass: "bottom_li",
                class: { active: _vm.active == index },
                on: {
                  click: function ($event) {
                    return _vm.getClick(index, item)
                  },
                },
              },
              [
                _c("img", {
                  staticClass: "navimg",
                  attrs: { src: item.icon, alt: "" },
                }),
                _c("span", { staticClass: "iconName" }, [
                  _vm._v(_vm._s(item.name)),
                ]),
              ]
            )
          }),
          0
        ),
      ]),
    ]),
    _c(
      "div",
      {
        staticClass: "aside_right",
        style: { width: _vm.isShows ? "246px" : "0" },
      },
      [
        _vm.isexhibit
          ? _c(
              "div",
              { staticClass: "aside_right_top" },
              [
                _c("div", { staticClass: "header" }, [_vm._v("大赛练习管理")]),
                _c("el-divider", { attrs: { "content-position": "center" } }, [
                  _vm._v(_vm._s(_vm.childrenMenuData.name)),
                ]),
              ],
              1
            )
          : _vm._e(),
        _vm.isexhibit
          ? _c("div", { staticClass: "aside_right_bottom" }, [
              _vm.isexhibit
                ? _c(
                    "div",
                    { staticClass: "aside_ul" },
                    _vm._l(_vm.childrenMenuChildren, function (item, index) {
                      return _c(
                        "div",
                        {
                          key: item.path,
                          staticClass: "navitem",
                          class: { active: _vm.actives == index },
                        },
                        [
                          _c(
                            "div",
                            {
                              class: {
                                "children-active": true,
                                actives: _vm.actives == item.id,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.getClicks(item, index)
                                },
                              },
                            },
                            [
                              _c("img", {
                                staticClass: "navimg",
                                attrs: { src: item.icon, alt: "" },
                              }),
                              _vm._v(" " + _vm._s(item.name) + " "),
                            ]
                          ),
                        ]
                      )
                    }),
                    0
                  )
                : _vm._e(),
            ])
          : _vm._e(),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "header" }, [
      _c("img", {
        staticClass: "logoImg",
        attrs: { src: require("../assets/image/home/lgo.png"), alt: "" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }